import axios from "axios";
import { API } from "./api";
import { getAttribution } from "./analytics";

export async function submitApplication(fields, cv) {
  const fd = new FormData();
  Object.entries({ ...getAttribution(), ...fields }).forEach(([k, v]) => { if (v) fd.append(k, v); });
  if (cv) fd.append("cv", cv);
  const { data } = await axios.post(`${API}/apply`, fd);
  return data;
}

export const isValidEmail = (e) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(e.trim());
export const isValidPhone = (p) => p.replace(/\D/g, "").length >= 10;
